import React from 'react';
import styled from 'styled-components';

import { PackageTitleStars } from '../PackageTitleStars';
import { displayPrice } from '../../utils';
import { colors, spacing } from '../../constants';

const PackageTitle = styled.div``;

interface IProps {
    bold?: boolean;
    className?: string;
    isDiscount?: boolean;
    isTotal?: boolean;
    item: string;
    price: number;
    starAmount?: number;
}

const BasePriceLine: React.FC<IProps> = ({
    item,
    price,
    className,
    isDiscount,
    starAmount,
}) => (
    <div className={className}>
        {starAmount ? (
            <PackageTitle>
                {item} <PackageTitleStars starAmount={starAmount} />
            </PackageTitle>
        ) : (
            item
        )}
        <span>
            {isDiscount && '-'} {displayPrice(price)}
        </span>
    </div>
);

export const PriceLine = styled(BasePriceLine)`
    padding: ${spacing.sm} 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: ${({ bold }) => (bold ? 700 : 400)};
    font-size: ${({ isTotal }) => (isTotal ? '18px' : '16px')};
    color: ${({ isDiscount }) => isDiscount && colors.primary};

    ${PackageTitle} {
        display: flex;
        align-items: center;
    }

    ${PackageTitleStars} {
        margin-left: 12px;
    }

    span {
        font-size: ${({ isTotal }) => (isTotal ? '20px' : '18px')};
        font-weight: ${({ bold }) => (bold ? 700 : 400)};
        font-family: 'Campton', Arial, Helvetica, sans-serif;
    }
`;
